module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Syriana.e23ccf5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Syriana.jpg
// module id = 7FXG
// module chunks = 0